<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="41.553" cy="37.5531" r="22.3114" transform="rotate(-45 41.553 37.5531)" stroke="#000000" stroke-width="4"/>
<path d="M57.33 53.3291L59.0625 55.0615M59.5956 55.5946L59.0625 55.0615M64.9262 60.9252L59.0625 55.0615" stroke="#000000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M79 75L72.1343 68.1343M71.5565 67.5565L72.1343 68.1343M65.7785 61.7785L72.1343 68.1343" stroke="#000000" stroke-width="7" stroke-linecap="square"/>
</svg>

</template>
